import './bittersweet/style';
import FormStructure from './bittersweet/form_structure';

export default FormStructure;